<template>
  <div>
    <!-- Success & Error Messages -->
    <div v-if="successMessage" class="alert alert-success" style="color: rgb(5, 20, 48)">
      {{ successMessage }}
    </div>
    <div v-if="errorMessage" class="alert alert-danger" style="color: red;">
      {{ errorMessage }}
    </div>

    <b-card>
      <b-row>
        <div class="col-12 mt-16">
          <b-form @submit.prevent="addExpenseType" v-if="show">
            <div style="background-color: rgb(97, 116, 152); height: 32px; border-radius: 4px;">
              <h4 style="color: rgb(223, 227, 238); margin-left: 5px; font-weight: bold;">
                Expense Type Information
              </h4>
            </div>
            <div class="row">
              <!-- Expense Type Name -->
              <div class="col-md-6 col-12">
                <b-form-group label="Expense Type Name:" label-for="name">
                  <b-form-input
                    id="name"
                    :state="validateField(name)"
                    placeholder="Enter expense type name"
                    v-model="name"
                    required
                  />
                </b-form-group>
              </div>
            </div>

            <!-- Submit -->
            <b-button type="submit" variant="primary" class="mb-8 mr-8" :disabled="isLoading">
              <span v-if="!isLoading">Save Expense Type</span>
              <b-spinner v-else small></b-spinner>
            </b-button>
          </b-form>
        </div>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BSpinner,
} from "bootstrap-vue";
import axios from "../../../axios";

export default {
  data() {
    return {
      show: true,
      isLoading: false,
      successMessage: "",
      errorMessage: "",

      // Expense Type field
      name: "",
    };
  },
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BSpinner,
  },
  methods: {
        validateField(value, type = "text") {
            if (value === null || value === undefined || value === "") return null;

            if (type === "email") {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return regex.test(value);
            }
            if (type === "number") {
            const regex = /^\+?[0-9 ]+$/; // accepts + and spaces
            return regex.test(value.toString().trim());
            }
            return value.toString().trim().length > 0;
        },
    addExpenseType() {
      this.isLoading = true;

      const formData = new FormData();
      formData.append("name", this.name);

      axios
        .post("/expenseTypesStore", formData) // <-- API endpoint for storing expense type
        .then(() => {
          this.$bvToast.toast("Expense type added successfully!", {
            title: "Success",
            variant: "primary",
            solid: true,
            toaster: "b-toaster-top-right",
            autoHideDelay: 5000,
          });
          this.isLoading = false;
          this.resetForm();
          this.$router.push({ name: "ListExpenseTypes" }); // <-- redirect after success
        })
        .catch((error) => {
          this.isLoading = false;
          this.$bvToast.toast(
            error.response?.data?.message || "An error occurred. Please try again.",
            {
              title: "Error",
              variant: "danger",
              solid: true,
              toaster: "b-toaster-top-right",
              autoHideDelay: 5000,
            }
          );
        });
    },
    resetForm() {
      this.name = "";
    },
  },
};
</script>
